import './App.css';
import Contact from './components/Contact/Contact';
import Cover from './components/Cover/Cover';
import Experience from './components/Experience/Experience';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Portfolio from './components/Portfolio/Portfolio';
import Resume from './components/Resume/Resume';


function App() {
  return (
    <>
      <Header />
      <Cover />
      <Portfolio />
      <Resume />
      <Experience />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
